<h2 *ngIf="usetype === 'commercial'" class="header"><i class="fa fa-cloud-download"></i>{{ 'URL_IMPORT' | translate }}
</h2>
<div class="url-import-container" [ngClass]="{'no-text': usetype !== 'commercial'}">
	<div class="url-import" [ngClass]="{disabled: !putRight}">

		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'URL_IMPORT' | translate}}</mat-label>
			<input [placeholder]="placeholder" [(ngModel)]="importUrl" matInput name="importUrl">
		</mat-form-field>

		<!-- <input type="text" [placeholder]="placeholder" class="join-right" (keyup.enter)="import()"
			[(ngModel)]="importUrl" /> -->
	</div>
	<button type="submit" class="button join-left"
		[ngClass]="{disabled: !putRight || !importUrl || importUrl === '' || waitForImport}" (click)="import()">
		<i class="fa" [ngClass]="{
								'fa-cloud-download':!importBusy,
								'fa-spin':importBusy,
								'disabled':importBusy,
								'fa-circle-o-notch':importBusy
							}">
		</i>
		{{ 'IMPORT' | translate }}
	</button>
</div>
